import PRProductsForm from '@app/components/apps/PRProducts/PRProductsForm';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';

const CreatePRProductPage = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Product Registration Product');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/product-registration-products',
      breadcrumbName: 'Product Registrations Products',
    },
    {
      path: '/add-product-registration-product',
      breadcrumbName: 'Add Product Registration Product',
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <PRProductsForm
        editable={true}
        pageTitle={'Create Product Registration Product'}
        type={'create'}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
      />
    </Row>
  );
};

export default CreatePRProductPage;
